import * as yup from "yup";
import {
	emailRegx,
	mobileNumberRegx,
} from "../../utils/regEx-pattern/regEx-pattern";

export const validationSchema = yup.object({
	fName: yup.string().required("First name is required"),
	lName: yup.string().required("Last name is required"),
	email: yup
		.string()
		.matches(emailRegx, "Please input the valid email address")
		.required("Email is required"),
	contact: yup
		.string()
		.matches(mobileNumberRegx, "Please input the valid number")
		.required("Contact is required"),
	gender: yup.string().required("Gender is required"),
	membershipPeriod: yup.mixed().required("Membership period is required"),
	birthDate: yup.date().max(new Date(), `Please put the valid birthdate`).required("Birthdate is required"),
	lacunaInfo: yup.mixed().required("Required"),
	password: yup.string().required("Password is required"),
});

export const initialValues = {
	fName: "",
	mName: "",
	lName: "",
	email: "",
	contact: "",
	membershipPeriod: "",
	gender: "",
	birthDate: "",
	lacunaInfo: "",
	companyName: "",
	password: "",
};

export const membershipOptions = [
	{
		label: "One Month",
		value: "1",
	},
	{
		label: "Two Month",
		value: "2",
	},
	{
		label: "Three Month",
		value: "3",
	},
];

export const radioOptions = [
	{
		label: "Male",
		value: "male",
	},
	{
		label: "Female",
		value: "female",
	},
];

export const lacunaInfoOptions = [
	{
		label: "Social Media",
		value: "social media",
	},
	{
		label: "Friend",
		value: "friend",
	},
	{
		label: "LinkedIn",
		value: "linkedIn",
	},
	{
		label: "Relatives",
		value: "relatives",
	},
	{
		label: "Fortunes",
		value: "fortunes",
	},
	{
		label: "Others",
		value: "others",
	},
];

export const applicationFields = [
	{
		name: "fName",
		label: "First Name",
		type: "text",
		required: true,
	},
	{
		name: "mName",
		label: "Middle Name",
		type: "text",
	},
	{
		name: "lName",
		label: "Last Name",
		type: "text",
		required: true,
	},
	{
		name: "email",
		label: "Email",
		type: "text",
		required: true,
	},
	{
		label: "Gender",
		name: "gender",
		options: radioOptions,
		type: "radio",
		required: true,
	},
	{
		label: "Birthdate",
		name: "birthDate",
		type: "date-picker",
		required: true,
	},
	{
		name: "contact",
		label: "Phone No.",
		type: "text",
		required: true,
	},
	{
		name: "companyName",
		label: "Company Name",
		type: "text",
	},
	{
		name: "membershipPeriod",
		label: "Membership Period",
		type: "react-select",
		required: true,
		options: membershipOptions,
	},
	{
		name: "lacunaInfo",
		label: "How did you know about lacuna ?",
		type: "react-select",
		required: true,
		options: lacunaInfoOptions,
	},
	{
		name: "password",
		label: "password",
		type: "password",
		required: true,
	},
];
